module.exports = ".title {\r\n    background: linear-gradient(-90deg, #FFFFCC, #ffc107)!important;\r\n    border-radius: .25rem!important;\r\n}"